import { type AgentUserConversation, type Organization, type Project } from "@overmap-ai/common"
import { persistSliceReducer, RESET_STATE } from "@overmap-ai/core"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import { APP_DATA_DB_NAME } from "../constants"

export interface AppSliceState {
	isLoggedIn: boolean
	// Active states:
	activeAgentConversationId: AgentUserConversation["uuid"] | null
	activeProjectId: Project["uuid"] | null
	activeOrganizationId: Organization["uuid"] | null
}

const initialState: AppSliceState = {
	isLoggedIn: false,
	// Active states:
	activeAgentConversationId: null,
	activeProjectId: null,
	activeOrganizationId: null,
}

export const appSlice = createSlice({
	name: "app",
	initialState,
	extraReducers: (builder) => builder.addCase(RESET_STATE, (state) => Object.assign(state, initialState)),
	reducers: {
		setLoggedIn: (state, action: PayloadAction<boolean>) => {
			state.isLoggedIn = action.payload
		},
		setActiveAgentConversationId: (state, action: PayloadAction<AgentUserConversation["uuid"] | null>) => {
			state.activeAgentConversationId = action.payload
		},
		setActiveOrganizationId: (state, action: PayloadAction<Organization["uuid"] | null>) => {
			state.activeOrganizationId = action.payload
		},
		setActiveProjectId: (state, action: PayloadAction<Project["uuid"] | null>) => {
			state.activeProjectId = action.payload
		},
	},
})

export const { setLoggedIn, setActiveAgentConversationId, setActiveOrganizationId, setActiveProjectId } =
	appSlice.actions

export const appReducer = persistSliceReducer(appSlice, APP_DATA_DB_NAME)
